/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const ReceiverLastNameColumnFormatter = (cellContent, row, rowIndex) => {
  const { receiverLastName } = row;

  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {receiverLastName ? receiverLastName : `-`}
      </div>
      <> </>
    </>
  );
};
